export const waitUntil = (
  predicate: () => boolean,
  timeoutMs = 5000,
  intervalMs = 50,
): Promise<void> =>
  new Promise((resolve, reject) => {
    const startedAt = Date.now();

    const tick = () => {
      if (predicate()) {
        resolve();
        return;
      }

      if (Date.now() - startedAt >= timeoutMs) {
        reject(new Error("Timed out waiting for Kakao SDK."));
        return;
      }

      window.setTimeout(tick, intervalMs);
    };

    tick();
  });
